module.exports = __webpack_public_path__ + "img/upload-id1.ca953bd4.png";